import type { RouterConfig } from '@nuxt/schema';

// Replaces the Nuxt 2 app/router.scrollBehavior.js. Vue Router 4 wants
// { left, top } instead of { x, y }, and `false` to keep the current position
// (the Nuxt 2 file returned a bare `0` for that case).
export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // Filters and pagination only rewrite the query, so the user stays put.
    // The Nuxt 2 file keyed this on `to.query` being non-empty, which no longer
    // holds: clearing a filter pushes every key as `undefined`, and Vue Router 4
    // drops those while Vue Router 3 kept them — so the same click that used to
    // land here with a three-key query now arrives with an empty one and threw
    // the user back to the top of the catalogue. The path is what actually
    // distinguishes a new page from a re-query.
    if (to.path === from.path) return false;
    if (savedPosition) return savedPosition;
    return { left: 0, top: 0 };
  },
};
